import { createRoot } from "react-dom/client";

import App from "./App";
import "./styles.css";

const root = document.querySelector<HTMLDivElement>("#root");
if (root === null) {
  throw new Error("ROOT_ELEMENT_MISSING");
}

createRoot(root).render(<App />);
